import React, { useCallback, useEffect, useId, useState } from "react";
import Popup from "devextreme-react/popup";
import DataGrid, { Column, Editing, RequiredRule } from "devextreme-react/data-grid";
import Guid from "devextreme/core/guid";
import applyChanges from "devextreme/data/apply_changes";
import { Tooltip } from "devextreme-react/tooltip";

const onInitialized = (e) => {
  // This is a hacky workaround. Without this, the popup closes when you click anywhere.
  let contentEl = e.component.content().parentElement;
  contentEl.className += "  dx-dropdowneditor-overlay";
};

const externalDocsRender = (e) => {
  const data = e.value || [];
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        {data.map((o, index) => (
          <a key={index} style={{ display: "block" }} href={o.url} target="_blank" rel="noopener noreferrer">
            {" "}
            {/* TODO: Don't use index as key */}
            {o.name}
          </a>
        ))}
      </div>
      <div>
        <i style={{ color: "#337ab7" }} className="dx-icon-edit"></i>
        <Tooltip target=".dx-icon-edit" showEvent="mouseenter" hideEvent="mouseleave">
          Double click to edit
        </Tooltip>
      </div>
    </div>
  );
};

const prepareDataSource = (data) => {
  // The DataGrid needs a unique key for each row. These don't exist for External Documents, so we add pseudo keys here.
  if (!data) {
    return [];
  }
  return data.map((o) => ({ ...o, id: new Guid().toString() }));
};

const ExternalDocsEditor = ({ data: cell }) => {
  const [dataSource, setDataSource] = useState(prepareDataSource(cell.value));
  const [isPopupVisible, setPopupVisibility] = useState(false);

  // useEffect(() => {
  //   setPopupVisibility(true);
  // }, []);

  // const onSaving = useCallback((e) => {
  //   e.cancel = true;

  //   if (e.changes.length > 0) {
  //     const ds = e.component.getDataSource().items();
  //     const newDs = applyChanges(ds, e.changes);
  //     setDataSource(newDs);
  //     cell.setValue(newDs);

  //     e.component.cancelEditData();
  //   }
  // }, []);

  const onSaving = useCallback((e) => {
    e.cancel = true;
  
    if (e.changes.length > 0) {
      // Preprocess URL changes to ensure they start with http:// or https://
      const processedChanges = e.changes.map(change => {
        console.log(change.type)
        if (change.data.url && !/^https?:\/\//.test(change.data.url)) {
          const updatedData = { ...change.data, url: `https://${change.data.url}` };
          return { ...change, data: updatedData };
        }
        return change;
      });
  
      const ds = e.component.getDataSource().items();
      // Apply the processed changes instead of the original changes
      const newDs = applyChanges(ds, processedChanges);
      setDataSource(newDs);
      cell.setValue(newDs);
  
      e.component.cancelEditData();
    }
  }, []);

  const showPopup = useCallback(() => {
    setPopupVisibility(true);
  }, []);

  const hidePopup = () => {
    setPopupVisibility(false);
  };

  return (
    <div
    // className="p-2"
    >
      <div style={{ display: "flex", justifyContent: "space-between", padding: 5 }}>
        <div>
          {dataSource?.map((o, index) => (
            <a key={index} style={{ display: "block" }} href={o.url} target="_blank" rel="noopener noreferrer">
              {" "}
              {/* TODO: Don't use index as key */}
              {o.name}
            </a>
          ))}
        </div>
        <div onClick={showPopup}>
          <i style={{ color: "#337ab7" }} className="dx-icon-edit" id={`edit-${cell.key}`}></i>
          <Tooltip target={`#edit-${cell.key}`} showEvent="mouseenter" hideEvent="mouseleave">
            Double click to edit
          </Tooltip>
        </div>
      </div>

      <Popup
        visible={isPopupVisible}
        hideOnOutsideClick={true}
        onHiding={hidePopup}
        onDisposing={hidePopup}
        maxWidth={800}
        onInitialized={onInitialized}
        title={`Edit external documents for: ${cell.data.master_doc_nm}`}
      >
        <DataGrid dataSource={dataSource} keyExpr="id" onSaving={onSaving}>
          <Editing allowAdding allowDeleting allowUpdating mode="batch" />
          <Column dataField="name" width={200}>
            <RequiredRule />
          </Column>
          <Column dataField="url">
            <RequiredRule />
          </Column>
        </DataGrid>
      </Popup>
    </div>
  );
};

export default ExternalDocsEditor;
